import { render, staticRenderFns } from "./batchModel.vue?vue&type=template&id=6e6cac1b&scoped=true&"
import script from "./batchModel.vue?vue&type=script&lang=js&"
export * from "./batchModel.vue?vue&type=script&lang=js&"
import style0 from "./batchModel.vue?vue&type=style&index=0&id=6e6cac1b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6cac1b",
  null
  
)

export default component.exports